import axios from './axiosConfig';

const api = {
    // 获取所有公司
    listAllOrg: () => axios.get('/org/list')
};
export default api;
